export const ACCESS_LEVEL = {
  read: "read",
  readWrite: "read_write",
};

/** UI/API action checks used by ActionGuard. */
export const ACTION = {
  access: "access",
  read: "read",
  write: "write",
};

export const ACCESS_LEVEL_RANK = {
  [ACCESS_LEVEL.read]: 1,
  [ACCESS_LEVEL.readWrite]: 2,
};

/** Seeded module keys — keep in sync with PermissionModules from API. */
export const MODULE = {
  dashboard: "dashboard",
  registrationManagement: "registration_management",
  investmentManagement: "investment_management",
  bondManagement: "bond_management",
  clientManagement: "client_management",
  userManagement: "user_management",
  cmsManagement: "cms_management",
  resourceManagement: "resource_management",
  appNotifications: "app_notifications",
  ipoManagement: "ipo_management",
  supportTickets: "support_tickets",
  closureRequests: "closure_requests",
};

/** Display names for API module `name` values — backend does not send labels. */
export const MODULE_LABELS = {
  [MODULE.dashboard]: "Dashboard",
  [MODULE.registrationManagement]: "Registration Management",
  [MODULE.investmentManagement]: "Order Management",
  [MODULE.bondManagement]: "Bond Management",
  [MODULE.clientManagement]: "Client Management",
  [MODULE.userManagement]: "User Management",
  [MODULE.cmsManagement]: "Content Management",
  [MODULE.resourceManagement]: "Manage Resources",
  [MODULE.appNotifications]: "Push Notifications",
  [MODULE.ipoManagement]: "IPO Management",
  [MODULE.supportTickets]: "Control Center",
  [MODULE.closureRequests]: "Closure Requests",
};

export const getModuleLabel = (name = "") => {
  if (MODULE_LABELS[name]) return MODULE_LABELS[name];

  return String(name)
    .split("_")
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(" ");
};
